// extracted by mini-css-extract-plugin
export var centerText = "_db-8";
export var container = "_db-0";
export var doughnutContainer = "_db-7";
export var legend = "_db-a";
export var legendItemColorDisplay = "_db-b";
export var legendItemLabel = "_db-d";
export var legendItemValue = "_db-c";
export var lg = "_db-5";
export var maxWidth = "_db-9";
export var md = "_db-4";
export var responsive = "_db-6";
export var sm = "_db-3";
export var xs = "_db-2";
export var xxs = "_db-1";